import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { AssetDropdownOption } from '../../../models/asset-dropdown-option.model';
import { Coordinates } from '../../../models/coordinates.model';
import { AdvancedMapSearchType } from '../../../models/advancedMap.model';
import { AcLineSegmentType, AuthService, SubstationTemplateDto, SubstationTemplateService, UtilitySharedService } from 'shared-lib';

@Component({
  selector: 'app-search-map-component',
  templateUrl: './search-map-component.component.html',
  styleUrl: './search-map-component.component.scss',
  standalone: false,
})
export class SearchMapComponentComponent implements OnInit {
  @Output() closeSearchClicked = new EventEmitter<boolean>();
  @Output() objectEmitter = new EventEmitter<AssetDropdownOption>();
  @Output() coordinates = new EventEmitter<Coordinates>();
  @Output() searchTypeSelected = new EventEmitter<AdvancedMapSearchType>();
  @Output() cimSubstationTemplateSelected = new EventEmitter<SubstationTemplateDto>();
  @Output() cimAcLineTypeSelected = new EventEmitter<{ id: number; name: string }>();
  slrnSearchOpen: boolean = false;
  AdvancedMapSearchType = AdvancedMapSearchType;

  searchType: AdvancedMapSearchType = AdvancedMapSearchType.None;

  assetNameDropdownOpened: boolean = false;
  assetSlrnDropdownOpened: boolean = false;

  hasCimDataIntegration: boolean = false;
  substationTemplates: SubstationTemplateDto[] = [];
  acLineSegmentTypes: { id: number; name: string }[] = [
    { id: AcLineSegmentType.Main, name: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.MAIN_AC_LINE' },
    { id: AcLineSegmentType.Incomer, name: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.INCOMER_AC_LINE' },
    { id: AcLineSegmentType.Primary, name: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.PRIMARY_AC_LINE' },
    { id: AcLineSegmentType.Boundary, name: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.BOUNDARY_AC_LINE' },
    { id: AcLineSegmentType.Secondary, name: 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.SECONDARY_AC_LINE' },
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private substationTemplateService: SubstationTemplateService,
    private utilitySharedService: UtilitySharedService
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  ngOnInit(): void {
    if (this.hasCimDataIntegration) {
      const utilityId = Number(this.utilitySharedService.getUtilityId());
      if (!utilityId) return;
      this.substationTemplateService.getAll(utilityId).subscribe({
        next: (response: any) => {
          const templates = response?.body?.data;
          this.substationTemplates = Array.isArray(templates) ? templates : [];
        }
      });
    }
  }

  closeSearch() {
    this.closeSearchClicked.emit(true);
  }

  getObject(obj: AssetDropdownOption) {
    this.objectEmitter.emit(obj);
  }

  emitCoordinates(coords: Coordinates) {
    this.coordinates.emit(coords);
  }

  onSlrnSearch() {
    this.slrnSearchOpen = !this.slrnSearchOpen;
  }

  openAssetNameDropdown() {
    this.assetNameDropdownOpened = !this.assetNameDropdownOpened;
  }

  openAssetSlrnDropdown() {
    this.assetSlrnDropdownOpened = !this.assetSlrnDropdownOpened;
  }

  onSearchType(type: AdvancedMapSearchType) {
    this.searchType = type;
    this.searchTypeSelected.emit(type);
  }

  onCimTemplateSearchType(template: SubstationTemplateDto) {
    this.searchType = AdvancedMapSearchType.AssetName_CimSubstation;
    this.cimSubstationTemplateSelected.emit(template);
  }

  onCimAcLineTypeSearchType(lineType: { id: number; name: string }) {
    this.searchType = AdvancedMapSearchType.AssetName_CimAcLine;
    this.cimAcLineTypeSelected.emit(lineType);
  }
}
